// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__hVkF4","btnOffer":"AddProduct_btnOffer__PRU6D"};